import { AuthenticatedGuard } from './routing-guard';
import { AdoptionRequestComponent } from '../app/adoptionrequest/adoptionrequest.component';
import { ClasslinkSSOLoginComponent } from '../app/classlink/classlink.component';
import { CollegeStudentSearchComponent } from '../app/collegestudentsearch/collegestudentsearch.component';
import { HomeComponent } from '../app/home/home.component';
import { IssueAlertComponent } from '../app/issuealert/issuealert.component';
import { IssueReportReviewComponent } from '../app/issuereportreview/issuereportreview.component';
import { LoginComponent } from '../app/login/login.component';
import { ManageAdoptionsComponent } from '../app/manageadoptions/manageadoptions.component';
import { ManageCoursesComponent } from '../app/managecourses/managecourses.component';
import { ManageDesigneesComponent } from '../app/managedesignees/managedesignees.component';
import { ManageScoresComponent } from '../app/managescores/managescores.component';
import { ManageStaffComponent } from '../app/managestaff/managestaff.component';
import { ManageTermsComponent } from '../app/manageterms/manageterms.component';
import { OfflineComponent } from '../app/offline/offline.component';
import { ParentContactComponent } from '../app/parentcontact/parentcontact.component';
import { ReportsComponent } from '../app/reports/reports.component';
import { RequestsComponent } from '../app/requests/requests.component';
import { SSOLoginComponent } from '../app/ssologin/ssologin.component';
import { StudentContactComponent } from '../app/studentcontact/studentcontact.component';
import { StudentSearchComponent } from '../app/studentsearch/studentsearch.component';
import { StudentSelectComponent } from '../app/studentselect/studentselect.component';
import { PageNotFoundComponent } from '../app/pagenotfound/pagenotfound.component';
import { AdminSettingsComponent } from '../app/admin-settings/admin-settings.component';
var ɵ0 = { roles: ['all'] }, ɵ1 = { roles: ['parent'] }, ɵ2 = { roles: ['parent'] }, ɵ3 = { roles: ['student'] }, ɵ4 = { roles: ['developer'] }, ɵ5 = { roles: ['counselor', 'schooladmin'] }, ɵ6 = { roles: ['counselor', 'schooladmin'] }, ɵ7 = { roles: ['all'] }, ɵ8 = { roles: ['all'] }, ɵ9 = { roles: ['counselor', 'schooladmin', 'districtadmin', 'developer'] }, ɵ10 = { roles: ['advisor', 'collegeadmin', 'collegesupport'] }, ɵ11 = { roles: ['districtadmin', 'developer'] }, ɵ12 = { roles: ['districtadmin', 'developer'] }, ɵ13 = { roles: ['collegeadmin', 'districtadmin', 'developer'] }, ɵ14 = { roles: ['collegeadmin', 'districtadmin', 'developer'] }, ɵ15 = { roles: ['districtadmin', 'developer'] }, ɵ16 = { roles: ['districtadmin', 'developer'] }, ɵ17 = { roles: ['developer'] }, ɵ18 = { roles: ['districtadmin', 'developer'] }, ɵ19 = { roles: ['counselor', 'schooladmin', 'districtadmin', 'advisor', 'collegeadmin', 'collegesupport', 'developer'] }, ɵ20 = { roles: ['student'] }, ɵ21 = { roles: ['all'] }, ɵ22 = { roles: ['all'] }, ɵ23 = { roles: ['all'] };
var routes = [
    {
        path: 'offline',
        component: OfflineComponent,
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'classlink',
        component: ClasslinkSSOLoginComponent,
    },
    {
        path: 'focussso',
        component: SSOLoginComponent,
    },
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0,
    },
    {
        path: 'studentselect',
        component: StudentSelectComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ1,
    },
    {
        path: 'parentcontact',
        component: ParentContactComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ2,
    },
    {
        path: 'studentcontact',
        component: StudentContactComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ3,
    },
    {
        path: 'adminsettings',
        component: AdminSettingsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ4,
    },
    {
        path: 'adoptionrequest/:CollegeCourseID',
        component: AdoptionRequestComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ5,
    },
    {
        path: 'adoptionrequest',
        component: AdoptionRequestComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ6,
    },
    {
        path: 'studentrecordview/:RecordID',
        component: RequestsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ7,
    },
    {
        path: 'studentrecordview/:StudentID/:RecordID',
        component: RequestsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ8,
    },
    {
        path: 'studentsearch',
        component: StudentSearchComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ9,
    },
    {
        path: 'collegestudentsearch',
        component: CollegeStudentSearchComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ10,
    },
    {
        path: 'manageadoptions',
        component: ManageAdoptionsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ11,
    },
    {
        path: 'managescores',
        component: ManageScoresComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ12,
    },
    {
        path: 'managestaff',
        component: ManageStaffComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ13,
    },
    {
        path: 'manageterms',
        component: ManageTermsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ14,
    },
    {
        path: 'managecourses',
        component: ManageCoursesComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ15,
    },
    {
        path: 'managedesignees',
        component: ManageDesigneesComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ16,
    },
    {
        path: 'issuealert',
        component: IssueAlertComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ17,
    },
    // NOTE: Temporarily diabled this route until tool can be linked to IIQ
    // {
    //     path: 'issuereport',
    //     component: IssueReportComponent,
    //     canActivate: [AuthenticatedGuard],
    //     data: { roles: ['all'] },
    // },
    {
        path: 'issuereporttracker',
        component: IssueReportReviewComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ18,
    },
    {
        path: 'reports',
        component: ReportsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ19,
    },
    {
        path: 'studentview',
        component: RequestsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ20,
    },
    {
        path: 'studentview/:StudentID',
        component: RequestsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ21,
    },
    {
        path: 'studentview/:RecordID/:StudentID',
        component: RequestsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ22,
    },
    {
        path: 'studentviewbyyear/:StudentID/:SchoolYear',
        component: RequestsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ23,
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: '/home',
    },
    { path: '**', component: PageNotFoundComponent },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23 };



// WEBPACK FOOTER //
// ./src/routes/app-routing.module.ts.pre-build-optimizer.js